var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReferFriend(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#212B36;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12,14.7c2.9,0,5.3-2.4,5.3-5.3C17.3,6.4,14.9,4,12,4C9.1,4,6.7,6.4,6.7,9.3C6.7,12.3,9.1,14.7,12,14.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.7,17.3c2.2,0,4-1.8,4-4c0-2.2-1.8-4-4-4s-4,1.8-4,4C18.7,15.5,20.5,17.3,22.7,17.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28,26.7c0.7,0,1.3-0.6,1.3-1.3c0-2.5-1.5-4.9-3.7-6c-2.3-1.1-5-0.8-7,0.7c-2.7-2.7-6.7-3.5-10.2-2 c-3.5,1.4-5.8,4.8-5.8,8.6C2.7,27.4,3.3,28,4,28h16c0.7,0,1.3-0.6,1.3-1.3"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferFriend);
export default __webpack_public_path__ + "static/media/refer_friend.b6c653fa9a2b1be4cd216a6837bb97b8.svg";
export { ForwardRef as ReactComponent };